import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const PageWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  width: '100dvw',
  height: '100dvw'
}); 